export const environment = {
  tier: 'staging',
  firebase: {
    apiKey: 'AIzaSyCi6hyMeHbqq6mKLMdWVqVjLg4SQNSbanA',
    authDomain: 'izyfisco-80213.firebaseapp.com',
    projectId: 'izyfisco-80213',
    storageBucket: 'izyfisco-80213.firebasestorage.app',
    messagingSenderId: '1047166020321',
    appId: '1:1047166020321:web:3cb006c80bda8f4d9a65a0',
    measurementId: 'G-Q25QCGDEGD',
    vapidKey:
      'BAAl96v0j2UhxhDjbaAoMrmgcT4sJqOUp6YxcWEOSKetd0erCk_CyVail6k6V3m5xNvgA54tzK4FXcPgxvhK8Rw',
  },
  production: false,
  backendDomain:
    'https://izy-back-backend-staging-994999224185.europe-southwest1.run.app',
  add_sleep_on_api_call: 0,
  // Vedi environment.ts: senza annotazione il confronto con 'uiltoscana' e' TS2367.
  style: null as string | null,
  version: null,
  theme: null,
  logoImage: 'izy-logo-short.png',
  fcmIcon: '/icons/icon-72x72.png',
  cookiePolicyUrl:
    'https://www.iubenda.com/privacy-policy/73477307/cookie-policy',
  termsUrl: 'https://www.iubenda.com/termini-e-condizioni/73477307',
  privacyPolicyUrl: 'https://www.iubenda.com/privacy-policy/73477307',
  consentVersion: '2026-07',
  // Zona pubblica di onboarding sul backend vero (OnboardingPublicService).
  onboardingMock: false,
};
